import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// Transparent access-token refresh on 401. Fixes cases where a long-idle
// authenticated user (JWT max_age=3600s) submits a mutation (e.g. Join meet-up)
// and gets "Not authenticated" — we refresh once via /auth/refresh and retry.
let refreshInFlight = null;
const REFRESH_PATH = "/auth/refresh";
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error?.config;
    const status = error?.response?.status;
    if (
      status === 401 &&
      original &&
      !original._retried &&
      !(original.url || "").endsWith(REFRESH_PATH)
    ) {
      original._retried = true;
      try {
        refreshInFlight = refreshInFlight || api.post(REFRESH_PATH).finally(() => { refreshInFlight = null; });
        await refreshInFlight;
        return api(original);
      } catch (_) {
        // fall through with the original 401
      }
    }
    return Promise.reject(error);
  }
);

export default api;

export const fileUrl = (path) => (path ? `${API}/files/${path}` : "");

export function errMsg(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (d === "subscription_required") return "An active subscription is needed for that — subscribe to continue.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ") || fallback;
  return fallback;
}

export const CATEGORIES = [
  "Tutoring", "Arts & Crafts", "Music", "Sports", "STEM",
  "Nature & Outdoors", "Language", "Co-op Classes", "Special Needs",
  "Educational Supplies", "Books", "Crafts", "Cleaning Products", "Other",
];

export const MARKETPLACE_CATEGORIES = ["Books", "Educational Supplies", "Crafts", "Cleaning Products", "Other"];

export const SELLER_PRODUCT_CATEGORIES = [
  "Curriculum and Learning Materials",
  "Educational Toys and Games",
  "Books Media and Printables",
  "Kids Clothing and Shoes",
  "Sports PE and Outdoor Gear",
  "Arts Crafts and Music",
  "Desks and Learning Space",
  "Tech Electronics and Lab Gear",
  "Baby and Toddler Essentials",
  "Handcrafted and Local Goods",
  "Free and Community Swap",
  "Other",
];

export const INTEREST_TAGS = ["Hiking", "Crafts", "Reading", "Sport", "Cooking", "Science", "Art", "Nature", "Music", "Gardening"];
